// @ts-check

/**
 * CUSTOM: Navnefelter på produktsiden – viser fejl og stopper "Læg i kurv", hvis et påkrævet navn mangler.
 * Markup: snippets/custom-name-personalization.liquid · CSS: assets/custom-name-personalization.css
 * Erstatter to inline <script> i snippets/product-form.liquid (7/10 2026).
 */
if (!customElements.get('custom-name-personalization')) {
  class CustomNamePersonalization extends HTMLElement {
    /**
     * Ren logik (ingen DOM): er alle felter udfyldt?
     * @param {string[]} values Feltværdier
     * @returns {boolean}
     */
    static allFilled(values) {
      return values.every((value) => value.trim() !== '');
    }

    connectedCallback() {
      /** @type {HTMLInputElement[]} */
      this.inputs = Array.from(this.querySelectorAll('input[data-personalization-input]'));
      this.error = this.querySelector('.personalization-error');
      if (this.inputs.length === 0 || this.dataset.required !== 'true') return;

      const isSingle = this.dataset.mode === 'single';
      this.inputs.forEach((input) => {
        input.addEventListener('input', () => {
          // Ét felt: vis fejlen igen, hvis feltet tømmes. Flere felter: skjul fejlen, når der skrives.
          this.toggleError(isSingle && input.value.trim() === '');
        });
      });

      const addToCart = this.closest('form')?.querySelector('[data-add-to-cart]');
      addToCart?.addEventListener('click', (event) => {
        if (CustomNamePersonalization.allFilled(this.inputs.map((input) => input.value))) return;
        event.preventDefault();
        event.stopPropagation();
        this.toggleError(true);
        this.inputs[0].focus();
      });
    }

    /** @param {boolean} show */
    toggleError(show) {
      this.error?.classList.toggle('is-visible', show);
    }
  }

  customElements.define('custom-name-personalization', CustomNamePersonalization);
}
